import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const SVG = ({
  className = '',
  size = '24'
}) => ___EmotionJSX("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  className: className,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, ___EmotionJSX("line", {
  x1: "19",
  y1: "4",
  x2: "10",
  y2: "4"
}), ___EmotionJSX("line", {
  x1: "14",
  y1: "20",
  x2: "5",
  y2: "20"
}), ___EmotionJSX("line", {
  x1: "15",
  y1: "4",
  x2: "9",
  y2: "20"
}));
export default SVG;